<template>
    <form @submit.prevent="onSubmit" :class="{ 'f3-wp-form-loading pointer-events-none': loading }">
        <f3-form    
            v-if="data"
            v-model="data"
            :config="config"
            :errors="errors"
            @file-change="onFileChange"
        />
        <div class="mt-8 w-1/2" v-if="!disableRecaptcha">
            <div class="g-recaptcha" :data-sitekey="recaptchaSiteKey" />
            <p class="text-danger text-xs mt-2 text-red-800" v-if="recaptchaError">{{ recaptchaError }}</p>
        </div>
    </form>
</template>

<script>
import axios from 'axios';
export default {
    data () {
        return {
            config: [],
            data: null,
            files: {},
            errors: {},
            // recaptchaSiteKey: window.recaptcha_site_key,
            recaptchaError: false,
            recaptchaToken: null,
            loading: false,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            emptyFieldValues: {
                'checkboxes': [],
                'checkbox': false
            },
            apiUrl: `${location.origin}/wp-json`
        }
    },
    props: {
        wpFormId: [String, Number],
        recaptchaSiteKey: {
            type: String,
            default: ''
        },
        disableRecaptcha: {
            type: Boolean,
            default: false
        }
    },
    mounted () {
        axios
            .get(`${this.apiUrl}/wp/v2/mcf_form/${this.wpFormId}`)
            .then((response) => {
                const data = {}
                let fields = response.data.acf.fields;
                this.config = fields.map(field => {
                    if (field.modelKey) {
                        data[field.modelKey] = this.emptyFieldValues.hasOwnProperty(field.component) ? this.emptyFieldValues[field.component] : ''
                    }
                    return this.formattedField(field)
                })
                this.data = data
            })
    },
    methods: {
        formattedField(field) {
            const cleanedField = { ...field }
            Object.keys(cleanedField).forEach(key => {
                if (!cleanedField[key]) {
                    delete cleanedField[key]
                }
            })
            cleanedField.name = cleanedField.modelKey
            return cleanedField
        },
        onSubmit() {
            this.recaptchaToken = !this.disableRecaptcha ? grecaptcha.getResponse() : null
            this.resetErrors()
            const data = this.getFormData()

            if (this.disableRecaptcha || (!this.disableRecaptcha && this.recaptchaToken)) {
                this.loading = true
                if (!this.disableRecaptcha) {
                    grecaptcha.reset();
                }
                axios
                    .post(`${this.apiUrl}/mcf/v1/form`, data, { headers: this.headers })
                    .then(response => {
                        this.$emit('success', this.data)
                        this.resetData()
                    })
                    .catch(error => {
                        const response = error.response;
                        if (response.status == 400) {
                            this.$emit('error-400')
                            this.errors = response.data.data
                        } else {
                            this.$emit('error')
                        }
                    })
                    .then(() => {
                        this.loading = false
                    })
            } else {
                this.recaptchaError = 'Le reCaptcha doit être validé pour soumettre le formulaire.'
            }
        },
        onFileChange(event) {
            if (event.data) {
                this.files[event.modelKey] = event.data
            }
        },
        getFormData() {
            const rawData = { ...this.data, ...this.files }
            let data = new FormData();
            data.append('form', this.wpFormId);
            if (!this.disableRecaptcha) {
                data.append('recaptcha_token', this.recaptchaToken);
            }
            Object.keys(rawData).forEach(key => {
                if (rawData[key] != '') {
                    data.append(key, rawData[key]);
                }
            })
            return data;
        },
        resetData() {
            this.config.forEach(field => {
                if (field.modelKey) {
                    this.data[field.modelKey] = this.emptyFieldValues.hasOwnProperty(field.component) ? this.emptyFieldValues[field.component] : ''
                }
            })
        },
        resetErrors() {
            this.recaptchaError = ''
            this.errors = {}
        }
    },
}
</script>

<style>
@keyframes f3-form-loading {
    0%,
    100% {
        opacity: .8;
    }
    50% {
        opacity: .3;
    }
}
/* @media (min-width: 768px) {
    .f3-wp-form {
        columns: 2;
        display: block !important;
    
        > * {
            @apply inline-block w-full;
        }
    }
} */

.f3-wp-form-loading {
    animation: f3-form-loading 2s infinite;
}
</style>